import {FeatureConfig} from '@/utils/constants/featuresFlag';
import {sanitizeBlobPath} from '@/utils/commons';
import {logger} from '@/helpers/logger';
import axios from 'axios';

export const useAzureBlob = () => {
  const VITE_BLOB_URL = import.meta.env[FeatureConfig.blobURL];

  const uploadFileOnBlob = async (sasResponse, file, onProgress) => {
    if (!sasResponse?.sasToken || !file) return;

    const safeDirectory = sanitizeBlobPath(sasResponse?.directory);
    const safeFileName = sanitizeBlobPath(sasResponse?.fileName);
    const uploadUrl = `${VITE_BLOB_URL}${safeDirectory}${safeFileName}?${sasResponse?.sasToken}`;

    try {
      const response = await axios.put(uploadUrl, file, {
        headers: {
          'x-ms-blob-type': 'BlockBlob',
          'Content-Type': file?.type || 'application/octet-stream'
        },
        onUploadProgress: (event) => {
          if (onProgress && event.lengthComputable) {
            const percent = Math.round((event.loaded / event.total) * 100);
            onProgress(percent);
          }
        }
      });

      if (response.status >= 200 && response.status < 300) {
        return {
          message: 'Success',
          media: {
            imageUrl: sasResponse?.blobUrl,
            filename: sasResponse?.fileName
          }
        };
      } else {
        logger.error('Upload failed', response.status, response.statusText);
        throw new Error('Upload failed');
      }
    } catch (error) {
      logger.error('Error uploading file:', error);
      throw new Error('Upload failed');
    }
  };

  const downloadFileOnBlob = async (sasResponse, fileDirectory, fileName) => {
    if (!sasResponse?.sasToken || !fileName) return;

    const safeDirectory = sanitizeBlobPath(fileDirectory);
    const uploadUrl = `${VITE_BLOB_URL}${safeDirectory}?${sasResponse?.sasToken}`;

    try {
      const response = await fetch(uploadUrl, {
        method: 'GET',
        headers: {
          'x-ms-blob-type': 'BlockBlob',
          'Content-Type': 'text/csv'
        }
      });

      if (!response.ok) {
        throw new Error('Download failed');
      }

      const responseText = await response.text();

      return {
        responseText,
        response
      };
    } catch (error) {
      logger.error('Error uploading file:', error);
      return error;
    }
  };
  const downloadFromBlobUrl = async (blobUrl, sasToken) => {
    if (!blobUrl || !sasToken) return null;
    try {
      const fileName = blobUrl?.split('/').pop();
      const directory = blobUrl?.split('/input')[1];
      const result = await downloadFileOnBlob({sasToken}, directory, fileName);
      return result?.responseText ?? null;
    } catch (error) {
      logger.error('Error downloading from blob URL:', error);
      return null;
    }
  };

  return {uploadFileOnBlob, downloadFileOnBlob, downloadFromBlobUrl};
};
